<script setup lang="ts">
  import Typography from '@/components/common/Typography.vue'
  import AppLayout from '@/components/layout/AppLayout.vue'
  import StandardLayout from '@/components/layout/Layout.vue'
  import { useI18n } from 'vue-i18n'

  const { t } = useI18n()
</script>

<template>
  <StandardLayout>
    <AppLayout>
      <div class="privacy">
        <Typography
          variant="h2"
          component="h1"
        >
          {{ t('privacyPage.title') }}
        </Typography>
        <Typography>
          {{ t('privacyPage.introduction') }}
        </Typography>

        <Typography variant="h3">
          {{ t('privacyPage.privacyHeader') }}
        </Typography>
        <Typography>
          {{ t('privacyPage.privacyText1') }} <a href="https://skole.aschehoug.no/personvern">{{ t('privacyPage.privacyText2') }}</a>
        </Typography>

        <Typography variant="h3">
          {{ t('privacyPage.agreementsHeader') }}
        </Typography>
        <Typography>
          {{ t('privacyPage.agreementsText') }}
          <a href="mailto:juridisk-utdanning@aschehoug.no?subject=Your%20Subject&body=Your%20Body">juridisk-utdanning@aschehoug.no</a>
        </Typography>

        <Typography variant="h3">
          {{ t('privacyPage.subcontractorsHeader') }}
        </Typography>
        <Typography>
          {{ t('privacyPage.subcontractorsText') }}
          <table>
            <tr>
              <th>{{ t('privacyPage.subcontractorsTableHeaders.name') }}</th>
              <th>{{ t('privacyPage.subcontractorsTableHeaders.serviceType') }}</th>
              <th>{{ t('privacyPage.subcontractorsTableHeaders.serverLocation') }}</th>
            </tr>
            <tr>
              <td>Amazon Web Services</td>
              <td>Serverdrift av Modus</td>
              <td>Sverige og Irland</td>
            </tr>
            <tr>
              <td>Pendo.io, Inc.</td>
              <td>Product analytics-verktøy</td>
              <td>Skytjeneste (innenfor EU/EØS)</td>
            </tr>
            <tr>
              <td>Redpill Linpro AS</td>
              <td>Serverdrift</td>
              <td>Norge</td>
            </tr>
          </table>
        </Typography>
        <Typography variant="h3">
          {{ t('privacyPage.contactHeader') }}
        </Typography>
        <Typography>
          {{ t('privacyPage.contactText') }}
          <a href="mailto:kontakt@aunivers.no?subject=Your%20Subject&body=Your%20Body">kontakt@aunivers.no</a>
        </Typography>
      </div>
    </AppLayout>
  </StandardLayout>
</template>

<style scoped lang="scss">
  .privacy {
    padding-top: 50px;
    max-width: 800px;
    margin: 0 auto;

    table {
      width: 100%;
      border-collapse: collapse;
      margin-top: 20px;
      background-color: #F2F2F2;

    }

    th, td {
      border: 1px solid #DDD;
      padding: 8px;
      text-align: left;
    }

    th {
      background-color: #F2F2F2;
    }

  }

</style>
